const normalizeUrl = (value = '') => {
  if (!value) {
    return '';
  }

  return value === '/' ? value : value.replace(/\/+$/, '');
};

const getWindowOrigin = () =>
  typeof window !== 'undefined' && window.location?.origin ? window.location.origin : '';

const apiUrl = normalizeUrl(process.env.REACT_APP_API_URL || '/api');
const uploadsBaseUrl = normalizeUrl(process.env.REACT_APP_UPLOADS_BASE_URL || getWindowOrigin());

export const env = {
  apiUrl,
  uploadsBaseUrl,
};
